import { useAtom } from "jotai";
import { nanoid } from "nanoid";
import React from "react";
import { AiOutlinePlus, AiOutlineUpload } from "react-icons/ai";
import { TbFileImport, TbFileExport } from "react-icons/tb";
import { createPrompt } from "../lib/createPrompt";
import { exportJson } from "../lib/exportJson";
import { validateFieldsData } from "../lib/validateFieldsData";
import {
  amountAtom,
  outputAtom,
  fieldObjectsAtom,
  currentIndexAtom,
  currentFieldsAtom,
  fieldsActionAtom,
} from "../state/global.state";

export const Buttons = () => {
  const [amount, setAmount] = useAtom(amountAtom);
  const [, setOutput] = useAtom(outputAtom);
  const [fieldsAction, setFieldsAction] = useAtom(fieldsActionAtom);
  const [fieldObjects] = useAtom(fieldObjectsAtom);
  const [currentIndex] = useAtom(currentIndexAtom);
  const [currentFields, setCurrentFields] = useAtom(currentFieldsAtom);

  const AddButton = () => {
    return (
      <button
        className="btn gap-2 !transition-none !transform-none normal-case"
        onClick={() => {
          const new_id = nanoid();
          const new_fields = [
            ...currentFields,
            {
              id: new_id,
              after: "",
              before: "",
              value: "",
            },
          ];
          setCurrentFields(() => new_fields);
          setFieldsAction(!fieldsAction);
        }}
      >
        <AiOutlinePlus />
        Add
      </button>
    );
  };
  const OutputButton = () => {
    return (
      <button
        className="btn btn-active btn-primary gap-2 !transition-none !transform-none normal-case"
        onClick={() => {
          const prompt = createPrompt({
            fields: currentFields,
            amount: amount,
          });
          setOutput(prompt);
        }}
      >
        <AiOutlineUpload />
        Output
      </button>
    );
  };
  return (
    <div className="flex justify-between flex-col gap-4 md:flex-row">
      <div className="flex gap-4">
        <AddButton />
        <OutputButton />
        <input
          type="number"
          value={amount}
          onChange={(e) => {
            setAmount(Number(e.target.value));
          }}
          className="input input-bordered input-{property} w-[80px] max-w-xs"
        />
      </div>
      <div className="flex gap-3 mt-auto">
        <label
          id="import_json"
          className="btn btn-sm gap-2 bg-slate-300 border-0 text-slate-700 normal-case hover:bg-slate-300"
        >
          <input
            type="file"
            id="import_json"
            className="hidden"
            accept=".json"
            onClick={(e) => {
              const target = e.target as HTMLInputElement;
              target.value = "";
            }}
            onChange={(e) => {
              try {
                if (e.target.files) {
                  const file = e.target.files[0];
                  const reader = new FileReader();
                  reader.readAsText(file);
                  reader.onload = (e) => {
                    if (e.target && e.target.result) {
                      const jsonData = JSON.parse(e.target.result as any);
                      const newData = validateFieldsData(jsonData);
                      if (newData) {
                        newData.forEach((field) => {
                          const new_id = nanoid();
                          field.id = new_id;
                        });
                        const newFields = [...currentFields, ...newData];
                        setCurrentFields(newFields);
                        setFieldsAction(!fieldsAction);
                      }
                    }
                  };
                }
              } catch (error) {
                alert("Import file is failed.");
                console.log(error);
              }
            }}
          />
          <TbFileImport />
          Import JSON
        </label>
        <button
          className="btn btn-sm gap-2 bg-slate-300 border-0 text-slate-700 normal-case hover:bg-slate-300"
          onClick={() => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const day = String(now.getDate()).padStart(2, "0");
            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            const formattedDateTime = `${year}${month}${day}${hours}${minutes}`;
            exportJson({
              fileName: fieldObjects[currentIndex].name + "_" + formattedDateTime + ".json",
              data: fieldObjects[currentIndex].fields,
            });
          }}
        >
          <TbFileExport />
          Export JSON
        </button>
      </div>
    </div>
  );
};
